import { getServiceName } from '@repo/utils';

import { IConDefaultType } from '../..';
import BubbleChatThrillIcon from './BubblechatThrillIcon';
import TingleThrillIcon from './TingleThrillIcon';

export enum ThrillIconVariant {
  DEFAULT = 'default',
  ONLY_ICON = 'only_icon',
  SIDE_MENU = 'side_menu',
}

export type IThrillIconProps = IConDefaultType & {
  variant?: ThrillIconVariant;
};

function ThrillIcon(props: IThrillIconProps) {
  const serviceName = getServiceName() as 'bubblechat' | 'tingle';
  const thrillIcons = {
    bubblechat: BubbleChatThrillIcon,
    tingle: TingleThrillIcon,
  } as const;

  const SelectedThrillIcon = thrillIcons[serviceName];

  return <SelectedThrillIcon {...props} />;
}

export default ThrillIcon;
